import { useTranslation } from 'react-i18next';
import { useRouteError } from 'react-router';
import { logger } from '@/shared/lib';
import { Button, EmptyState } from '@/shared/ui';

/** Ошибка рендера маршрута (вместо классового ErrorBoundary — errorElement роутера). */
export function RouteError() {
  const { t } = useTranslation('shell');
  const error = useRouteError();
  logger.error('route: render error', {
    error: error instanceof Error ? error.message : String(error),
  });
  return (
    <div className="flex min-h-screen min-w-1280 items-center justify-center bg-paper-deep px-24">
      <div className="w-480 rounded-20 border border-line-strong bg-paper-pure">
        <EmptyState
          title={t('routeError.title')}
          note={t('routeError.note')}
          action={
            <Button variant="outline" size="sm" onClick={() => window.location.reload()}>
              {t('routeError.reload')}
            </Button>
          }
        />
      </div>
    </div>
  );
}
